/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommMobileIsoData } from './ecomm-mobile-iso.data';
import { IEcommMobileIsoProps } from './ecomm-mobile-iso.props.autogenerated';

export interface IEcommMobileIsoViewProps extends IEcommMobileIsoProps<IEcommMobileIsoData> {}

/**
 *
 * EcommMobileIso component
 * @extends {React.PureComponent<IEcommMobileIsoProps<IEcommMobileIsoData>>}
 */
class EcommMobileIso extends React.PureComponent<IEcommMobileIsoProps<IEcommMobileIsoData>> {
  public render(): JSX.Element | null {
    return this.props.renderView(this.props);
  }
}

export default EcommMobileIso;
